import type * as FullWidthPromo from '../types/FullWidthPromo'
import { imageParser } from '../props/parsers/Image'

export default function textBlockComponentParser(
  rawComponent: FullWidthPromo.Raw,
): FullWidthPromo.Parsed {
  const {
    headlineText,
    bodyText,
    image,
    links,
    singleMultipleLinks,
    link,
    ...rest
  } = rawComponent.fullWidthPromo

  const cta: FullWidthPromo.CTA = {
    headlineText,
    bodyText,
  }

  if (singleMultipleLinks === 'multiple' && links) {
    cta.links = links.map(({ link }) => link)
  } else {
    cta.link = link
  }

  return {
    name: 'FullWidthPromo',
    props: {
      ...imageParser(image),
      cta,
      ...rest,
    },
  }
}
